import { InteractionToCompleteViewExperience } from 'types/amethyst';

export const EXPERIENCE_MAP: Record<string, InteractionToCompleteViewExperience> = {
  'cart_modal:login': InteractionToCompleteViewExperience.CART_MODAL_TO_CHECKOUT_LOGIN,
  'cart_modal:payment': InteractionToCompleteViewExperience.CART_MODAL_TO_CHECKOUT_PAYMENT,
  'cart_modal:review': InteractionToCompleteViewExperience.CART_MODAL_TO_CHECKOUT_REVIEW,
  'cart_modal:shipping': InteractionToCompleteViewExperience.CART_MODAL_TO_CHECKOUT_SHIPPING,
  'payment:review': InteractionToCompleteViewExperience.CHECKOUT_PAYMENT_TO_REVIEW,
  'shipping:payment': InteractionToCompleteViewExperience.CHECKOUT_SHIPPING_TO_PAYMENT
} as const;

export const STORAGE_KEY = 'kratos_click_to_display';
export const DEFAULT_MAX_AGE_MS = 5 * 60 * 1000; // 5 minutes
